// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1___f6caaf514183eedaefd","cls2":"Header-cls2___c586b828026638b19f1 Header-cls1___f6caaf514183eedaefd"};